import Decision from 'slotworks/state-machine/decisions/decision';
import { Exit } from 'slotworks/state-machine/data/exit';
import gameState from 'slotworks/model/game-state';
import FreespinsWheelRecord from 'integration/records/freespins-wheel-record';
import FreespinsWheelResult from 'integration/results/freespins-wheel-result';

export default class IsFreespinsWheel extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if(record instanceof FreespinsWheelRecord) {
            return Exit.True;
        } 
        
        if(record.getResultsOfType(FreespinsWheelResult).length > 0) {
            return Exit.True;
        }

        return Exit.False;
    }
}